import { render } from "./ChartExpansionNotesModal.vue?vue&type=template&id=2a43bdd4"
import script from "./ChartExpansionNotesModal.vue?vue&type=script&lang=js"
export * from "./ChartExpansionNotesModal.vue?vue&type=script&lang=js"

import "./ChartExpansionNotesModal.vue?vue&type=style&index=0&id=2a43bdd4&lang=scss"

import exportComponent from "/home/runner/work/rust-webserver/rust-webserver/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__